import DataTypeModel from '../../../../models/DataType'
import apiUrl from '../../../Url/ApiUrl'
import { get, post } from '../../../methods'
import getFullUrl from '../../../../helpers/functions/getFullUrl'

export const getMemsourceProjects = (parameters, cancelToken) =>
    post(apiUrl.projects.memsourceProjectsList, DataTypeModel(parameters), cancelToken)

export const getMemsourceValidatorNames = (parameters) =>
    get(apiUrl.projects.memsourceValidatorNames, DataTypeModel(parameters))

export const getMemsourceLanguages = (parameters) =>
    get(apiUrl.languages.memsourceLanguagesList, DataTypeModel(parameters))

export const getMemsourceWorkflowStatus = (parameters) =>
    get(apiUrl.projects.memsourceWorkflowStatus, DataTypeModel(parameters))

export const getMemsourceProject = (uriParams) => get(apiUrl.projects.memsourceProject, DataTypeModel({}, uriParams))

export const getMemsourceProjectListInCsvUrl = (parameters) =>
    getFullUrl(apiUrl.projects.memsourceProjectsListCsv, DataTypeModel(parameters))

export const putMemsourceProjectCancel = (projectUid) =>
    post(apiUrl.projects.memsourceProjectCancel, DataTypeModel({ projectUid }))

export const putMemsourceQuoteAccept = (projectUid) =>
    post(apiUrl.projects.memsourceQuoteAccept, DataTypeModel({ projectUid }))

export const postRefreshProject = (projectUid, email) =>
    post(apiUrl.projects.memsourceRefreshProject, DataTypeModel({ projectUid, email }))
